var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_59)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2233 70.9255C72.2578 70.155 73.8986 67.8871 72.1851 64.9802L54.3731 49.703L38.3103 34.9247C38.3005 34.2269 37.8667 33.1164 36.2101 34.2563L33.8056 36.7326C33.467 37.4352 33.1383 38.8355 34.5318 38.8159L49.7359 54.4787L65.6612 71.8759C66.6557 72.3854 69.1603 72.9085 71.2233 70.9255Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3094 28.1712C51.0693 28.3724 52.51 29.4282 55.0626 31.6547C57.8554 34.091 61.9219 38.6008 62.7164 40.1432C63.179 41.0412 63.1664 42.3067 62.6852 43.2851C62.3146 44.0383 44.1701 62.3263 43.4198 62.7029C42.4215 63.2038 41.1749 63.215 40.2287 62.7315C39.0938 62.1516 35.752 59.3294 33.5292 57.0736C31.2178 54.7279 28.7523 51.7725 28.3422 50.8559C27.9291 49.9322 28.0253 48.5877 28.5713 47.6538C28.8145 47.2379 46.4459 29.404 47.1875 28.8238C48.0725 28.1313 49.2383 27.8876 50.3094 28.1712Z",
    fill: "url(#paint1_linear_1062_59)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3094 28.1712C51.0693 28.3724 52.51 29.4282 55.0626 31.6547C57.8554 34.091 61.9219 38.6008 62.7164 40.1432C63.179 41.0412 63.1664 42.3067 62.6852 43.2851C62.3146 44.0383 44.1701 62.3263 43.4198 62.7029C42.4215 63.2038 41.1749 63.215 40.2287 62.7315C39.0938 62.1516 35.752 59.3294 33.5292 57.0736C31.2178 54.7279 28.7523 51.7725 28.3422 50.8559C27.9291 49.9322 28.0253 48.5877 28.5713 47.6538C28.8145 47.2379 46.4459 29.404 47.1875 28.8238C48.0725 28.1313 49.2383 27.8876 50.3094 28.1712Z",
    stroke: "url(#paint2_linear_1062_59)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_59",
    x: 25.9369,
    y: 25.9057,
    width: 39.2678,
    height: 39.3312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_59",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_59",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_59",
    x1: 59.2673,
    y1: 31.2444,
    x2: 21.5692,
    y2: 50.9585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_59",
    x1: 42.6067,
    y1: 33.9162,
    x2: 29.6062,
    y2: 64.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.2d3273b5d47caea3a779cfb6004c638d.svg";
export { ForwardRef as ReactComponent };